/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conflict_OverwriteInputs */

const cs_ebr_conflict_overwrite = /** @type {(inputs: Ebr_Conflict_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepsat`)
};

const en_ebr_conflict_overwrite = /** @type {(inputs: Ebr_Conflict_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite`)
};

/**
* | output |
* | --- |
* | "Overwrite" |
*
* @param {Ebr_Conflict_OverwriteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conflict_overwrite = /** @type {((inputs?: Ebr_Conflict_OverwriteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conflict_OverwriteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conflict_overwrite(inputs)
	return cs_ebr_conflict_overwrite(inputs)
});